'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_MealPlanner$Dialog$() {
  this.lr = null;
  this.nC = null;
  this.mD = false;
  this.dv = 0;
  this.al = null;
  this.nB = 0;
  this.jj = 0;
  this.oO = null;
  this.oP = false;
  this.oQ = null;
  this.oR = false;
  this.a6E = null;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_s_Enumeration__I__(this, 0);
  $n_Lmealorama_components_MealPlanner$Dialog$ = this;
  var name = (((this.al !== null) && this.al.l()) ? this.al.k() : "addMealDialog");
  this.a6E = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Enumeration$Val(this, this.dv, name);
}
export { $c_Lmealorama_components_MealPlanner$Dialog$ as $c_Lmealorama_components_MealPlanner$Dialog$ };
$p = $c_Lmealorama_components_MealPlanner$Dialog$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_s_Enumeration();
$p.constructor = $c_Lmealorama_components_MealPlanner$Dialog$;
/** @constructor */
function $h_Lmealorama_components_MealPlanner$Dialog$() {
}
export { $h_Lmealorama_components_MealPlanner$Dialog$ as $h_Lmealorama_components_MealPlanner$Dialog$ };
$h_Lmealorama_components_MealPlanner$Dialog$.prototype = $p;
var $d_Lmealorama_components_MealPlanner$Dialog$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_MealPlanner$Dialog$, "mealorama.components.MealPlanner$Dialog$", ({
  Hq: 1,
  aX: 1,
  a: 1
}));
export { $d_Lmealorama_components_MealPlanner$Dialog$ as $d_Lmealorama_components_MealPlanner$Dialog$ };
var $n_Lmealorama_components_MealPlanner$Dialog$;
function $m_Lmealorama_components_MealPlanner$Dialog$() {
  if ((!$n_Lmealorama_components_MealPlanner$Dialog$)) {
    $n_Lmealorama_components_MealPlanner$Dialog$ = new $c_Lmealorama_components_MealPlanner$Dialog$();
  }
  return $n_Lmealorama_components_MealPlanner$Dialog$;
}
export { $m_Lmealorama_components_MealPlanner$Dialog$ as $m_Lmealorama_components_MealPlanner$Dialog$ };
//# sourceMappingURL=mealorama.components.-Meal-Planner$-Dialog$.js.map
